<template>
  <qx-card title="人员分布">
    <section v-loading="loading">
      <qx-card-form title="功能权限">
        <JurisdictionBox
          type="user"
          ref="btnMenu"
          v-model="btnMenu"
        />
      </qx-card-form>
      <qx-card-form title="数据权限">
        <JurisdictionBox
          type="user"
          ref="dataMenu"
          v-model="dataMenu"
        />
      </qx-card-form>
    </section>
  </qx-card>
</template>

<script>
import {
  jurisdictionList,
} from 'api/system';
import JurisdictionBox from 'components/jurisdictionBox/jurisdictionBox.vue';
export default {
  components: {
    JurisdictionBox,
  },
  data () {
    return {
      btnMenu: [],
      dataMenu: [],
    };
  },
  async created () {
    this.loading = true;
    const jurisdictionRes = await jurisdictionList();
    this.loading = false;
    this.btnMenu = jurisdictionRes.sysMenu1.childMenus;
    this.dataMenu = jurisdictionRes.sysMenu2.childMenus;
  },
};
</script>

<style scoped lang="scss">
.title{
  height: 32px;
  line-height: 32px;
}
</style>
